export default __webpack_public_path__ + "static/media/tglogo.a6ccfc8f.svg";